var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"loader-spinner",class:_vm.classSize,attrs:{"src":require("@/assets/img/spinner.gif"),"alt":"loading..."}})}
var staticRenderFns = []

export { render, staticRenderFns }